var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isBtnVisible)?_c('v-btn',{staticClass:"button-base",attrs:{"depressed":"","color":"primary","isLoading":_vm.isLoading},on:{"click":_vm.btnClickHandler}},[_vm._v(" Оформить довзыскание ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }